import React from "react";

import cx from "classnames";

import InlineLabel from "./InlineLabel";

import styles from "./BetaLabel.module.css";

export default function BetaLabel({ className }: { className?: string }) {
	return <InlineLabel className={cx(styles.betaLabel, className)} text="Beta" />;
}
